import React from 'react'
import { observer } from 'mobx-react'
import { storeMobx, timePickMobx } from '@mobxStore'
import TimePickController from '@ctrls/timePickController'
import './index.scss'

export interface IPreOrderButtonProps {
  type: TEatType;
}

const PreOrderButton: React.FC<IPreOrderButtonProps> = (props) => {
  const { type } = props

  /** 堂食送餐制，不需要预约 */
  if (!timePickMobx.canBookingTime) {
    return null
  }
  if (!storeMobx.info.isMobileBookingOrder || !timePickMobx.canPick) {
    return null
  }

  const handlePreOrder = () => {
    TimePickController.handleAppointment()
  }

  return (
    <button className='pre-order-button' type='button' onClick={handlePreOrder}>
      <i className='iconfont icon-time2x'></i>
      {
        timePickMobx.selectedInfo?.pickTime ? (
          <span>
            {i18n.t(`newCart.timeFor_${type}`, {
              time: timePickMobx.getTimeText('default'),
            })}
          </span>
        ) : <span>{i18n.t(`newCart.booking_${type}`)}</span>
      }
    </button>
  )
}

export default observer(PreOrderButton)
